// icons/shared/files.svg

export const FilesIcon = (props) => (
  <svg
    className={props.className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.875 4.5C20.1875 4.5 20.4531 4.60938 20.6719 4.82812C20.8906 5.04688 21 5.3125 21 5.625V19.875C21 20.1875 20.8906 20.4531 20.6719 20.6719C20.4531 20.8906 20.1875 21 19.875 21H8.625C8.3125 21 8.04688 20.8906 7.82812 20.6719C7.60938 20.4531 7.5 20.1875 7.5 19.875V16.5H1.125C0.8125 16.5 0.546875 16.3906 0.328125 16.1719C0.109375 15.9531 0 15.6875 0 15.375V7.5C0 7.1875 0.078125 6.84375 0.234375 6.46875C0.390625 6.09375 0.578125 5.79688 0.796875 5.57812L5.57812 0.796875C5.79688 0.578125 6.09375 0.390625 6.46875 0.234375C6.84375 0.078125 7.1875 0 7.5 0H12.375C12.6875 0 12.9531 0.109375 13.1719 0.328125C13.3906 0.546875 13.5 0.8125 13.5 1.125V4.96875C14.0312 4.65625 14.5312 4.5 15 4.5H19.875ZM13.5 6.99609L9.99609 10.5H13.5V6.99609ZM6 2.49609L2.49609 6H6V2.49609ZM8.29688 10.0781L12 6.375V1.5H7.5V6.375C7.5 6.6875 7.39062 6.95312 7.17188 7.17188C6.95312 7.39062 6.6875 7.5 6.375 7.5H1.5V15H7.5V12C7.5 11.6875 7.57812 11.3438 7.73438 10.9688C7.89062 10.5938 8.07812 10.2969 8.29688 10.0781ZM19.5 19.5V6H15V10.875C15 11.1875 14.8906 11.4531 14.6719 11.6719C14.4531 11.8906 14.1875 12 13.875 12H9V19.5H19.5Z"
      fill="#34363E"
    />
  </svg>
);
